import { render, staticRenderFns } from "./Chatgpt.vue?vue&type=template&id=388f5571&scoped=true"
import script from "./Chatgpt.vue?vue&type=script&lang=js"
export * from "./Chatgpt.vue?vue&type=script&lang=js"
import style0 from "./Chatgpt.vue?vue&type=style&index=0&id=388f5571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f5571",
  null
  
)

export default component.exports